export default __webpack_public_path__ + "static/media/B0007.080d1114.png";